// Charge inconditionnellement dans cart-drawer.liquid ET main-cart.liquid (voir
// commentaire a cote de chaque <script src="..."> qui le charge). Le custom element
// cozora-upsell est defini par ce module, jamais dans le snippet cozora-cart-upsell.liquid
// lui-meme : ce snippet ne se rend qu'une fois cart.items non vide, donc au premier
// chargement de page avec un panier vide le snippet (et un <script> qu'il porterait)
// n'existe pas -- il arrive plus tard via morphSection() apres le premier ajout, et un
// <script> insere par morph/innerHTML n'execute jamais (comportement du DOM). En
// chargeant la classe ici, au premier rendu de page, le custom element s'auto-upgrade
// correctement des que le snippet apparait dans le DOM, quel que soit le moment.
import { CartLinesUpdateEvent } from '@shopify/events';

if (!customElements.get('cozora-upsell')) {
  customElements.define(
    'cozora-upsell',
    class extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-cz-add]')?.addEventListener('click', () => this.#add(), { once: true });
      }

      async #add() {
        const button = this.querySelector('[data-cz-add]');
        const id = Number(this.dataset.variantId);
        if (!id) return;
        if (button) button.disabled = true;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'cart',
            lines: [{ id: String(id), quantity: 1 }],
            promise: deferred.promise,
          })
        );

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id, quantity: 1 }],
              sections: this.dataset.sections,
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'add failed');
          }
          // Pas de createCartFromAjaxResponse ici : elle attend un panier
          // complet et /cart/add.js ne renvoie que { items, sections }, sans
          // devise. Elle leve « Currency code is required with currency
          // style », l'exception tombait dans le catch et le panier ne se
          // rafraichissait jamais. Les deux consommateurs du theme,
          // cart-drawer et component-cart-items, ne lisent que detail.
          deferred.resolve({
            detail: {
              sections: data.sections,
              items: data.items,
              source: 'cozora-upsell',
              didError: false,
            },
          });
        } catch (error) {
          deferred.reject(error);
          if (button) {
            button.disabled = false;
            button.addEventListener('click', () => this.#add(), { once: true });
          }
          console.warn('[cozora-upsell]', error);
        }
      }
    }
  );
}
